import React, { useState, useRef } from "react";
import "./footer.css"; 
import logo from "../../../assets/img/logo-color.png";
import Terms from "../../../pages/terms/Terms";
import Privacy from "../../../pages/privacy/Privacy";

function Footer() {
  const [showModal, setShowModal] = useState(null);
  const footerRef = useRef(null);

  return (
    <>
      <footer ref={footerRef} className="gakkaun-main-footer">
        <div className="gakkaun-footer-inner">
        <div className="gakkaun-footer-top-row">
          <div className="gakkaun-footer-top-links">
            <button onClick={() => setShowModal('terms')} className="gakkaun-footer-link">이용약관</button>
            <button onClick={() => setShowModal('privacy')} className="gakkaun-footer-link">개인정보처리방침</button>
          </div>
          <div className="gakkaun-footer-top-button">
            <button 
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} 
              className="gakkaun-footer-link"
              aria-label="맨 위로 이동"
            >
              TOP
            </button>
          </div>
        </div>
        <hr className="gakkaun-footer-divider" />
        <div className="gakkaun-footer-main-row">
          <div className="gakkaun-footer-logo-area">
            <img src={logo} alt="가까운 물류 로고" className="gakkaun-footer-logo" loading="lazy" />
          </div>
          <div className="gakkaun-footer-info-center">
            <span className="gakkaun-footer-info-title">회사명</span> (주) 가까운 물류
            <span className="gakkaun-footer-info-title">대표이사</span> 김종은
            <br />
            <span className="gakkaun-footer-info-title gakkaun-footer-info-title--no-margin">주소</span>{" "}
            부산시 강서구 맥도길509번길 30
            <span className="gakkaun-footer-info-title">TEL</span> 070-5009-3313
            <br />
            <span className="gakkaun-footer-info-title gakkaun-footer-info-title--no-margin">E-mail</span> h0118899795@naver.com
          </div>
        </div>
        <div className="gakkaun-footer-bottom-row">
          <div className="gakkaun-footer-copyright-center">
            Copyright {new Date().getFullYear()} ⓒ 가까운 물류. All Rights Reserved. Hosting Design by 가까운 물류.
          </div>
        </div>
        </div>
      </footer>
      
      {/* 모달 렌더링 */}
      {showModal === 'terms' && <Terms onClose={() => setShowModal(null)} />}
      {showModal === 'privacy' && <Privacy onClose={() => setShowModal(null)} />}
    </>
  );
}

export default Footer;
